<template>
  <div class="kw_list_comment">
    <div class="commentBox" v-for="(dataInfo,dataIndex) in treeArr" :key="dataIndex" >
      <div class="commentBox_down">
        <!-- 一条评论内容 -->
        <div class="comment">
          <img class="headPortrait" :src="(dataInfo.STU_SEX==1?require('./img/manImg.png'):dataInfo.STU_SEX==2?require('./img/womanImg.png'):require('./img/emptyImg.png'))"/>
          <div class="nameBox">
            <span class="name">{{dataInfo.USER_NAME}}</span>
            <span>{{dataInfo.TIME}}</span>
          </div>
          <div v-if="pageSetInfo.listFieldSet">
            <kw_having_view :initDataInfo="dataInfo" :initPageSetInfo="pageSetInfo"></kw_having_view>
          </div>
        </div>
        <!-- 是否文本超出截取 -->
        <div v-if="(dataInfo.whetherFold)" class="commentText">
            <span>{{dataInfo.NAME}}</span>
        </div>
        <div v-else class="commentText">
          <div v-if="(('isExpansion0'+dataInfo.LMF_ID) != isExpansion)">
            <span>{{dataInfo.sliceNAME}}</span>
            <span class="toggleExpand" @click="ctlExpansion('isExpansion0'+dataInfo.LMF_ID)" :id="('isExpansion0'+dataInfo.LMF_ID)">展开</span>
          </div> 
          <div v-else>
            <pre style="white-space: pre-line;">{{dataInfo.NAME}}</pre>
            <span class="toggleExpand" @click="ctlExpansion('isExpansion'+dataInfo.LMF_ID)" :id="('isExpansion'+dataInfo.LMF_ID)" key="0">收起</span>
          </div>
        </div>
        <div class="commentImageArray">
          <div v-for="(bgFileInfo,dataIndex) in dataInfo.BG_FILE" :key="dataIndex" >
            <kw_preview_image :zdyClass="'commentImg'" :styleSet="pageSetInfo.listStyleSet" :imgSrc="bgFileInfo" :imgSrcArr="dataInfo.BG_FILE"></kw_preview_image>
          </div>
        </div>
        <!-- 评论的回复信息 -->
        <div v-if="(dataInfo.children && dataInfo.children.length > 0)">
          <div v-for="(childInfo,childIndex) in dataInfo.children" :key="childIndex" >
            <span :decode="true" class="authorReply">作者&nbsp;回复</span>
            <div>
              <span>{{dataInfo.USER_NAME}}:</span>
              <span>{{dataInfo.NAME}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

// 图片预览组件 kw_preview_image
import kw_preview_image from '@/components/look/kw_preview_image.vue';
// 状态聚合组件 
import kw_having_view from '@/components/look/kw_having_view.vue';

import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';

export default {
  name: 'kw_list_comment',
  props: {
    pageSetInfo: {
      type: Object,
      default: null
    },
    listFieldSet: {
      type: Array,
      default: null
    },
    //列表数据全部显示
    dataList: {
      type: Array,
      default: null
    },
    //单一一条数据进行显示
    dataInfo: {
      type: Object,
      default: null
    },
    initDataIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      // 展开状态
      isExpansion:"",
      treeArr:[]
    };
  },
  created() {
    this.updataRate();
  },
  mounted() {
    
  },
  watch:{
    dataList:function(newVal){
      this.updataRate();
    }
  },
  computed:{
  },
  components: {
    kw_preview_image,
    kw_having_view
  },
  methods: {
    updataRate(){
      //console.log(this.data.dataList, "kw_list_commentkw_list_commentkw_list_comment----------0000")
      if (this.dataList) {
        var dataList = this.dataList;
        dataList.forEach(i => {
          if (i.BG_FILE) {
            var arr = i.BG_FILE.split(",");
            i.BG_FILE = arr;
          }
          if (i.NAME) {
            i.NAME = i.NAME.replace(/_@/g, "\n");
            if ((i.NAME).length > 48) {
              i.sliceNAME = i.NAME.slice(0, 48) + '...';
              i.whetherFold = false;
            } else {
              i.whetherFold = true;
            }
          } else {
            i.whetherFold = true;
          }
        })
        this.treeArr = pageUtils.buildTree(dataList);
        console.log("this.treeArr=============================",this.treeArr);
        this.whetherFold = true;  //false:不折叠  遍历数组，name文本大于指定书目时设置为false   false：折叠
      }
    },


    /**
     * 列表数据点击时 进行跳转
     */
    listDataClick(dataInfo) {
      pageUtils.listDataClick(this, dataInfo);
    },
    /**
     * 列表按钮点击事件
     */
    dataButtonClick: function (detail,dataInfo) {
      pageUtils.dataButtonClick(this,detail,dataInfo);
    },
    //评论内容展开收起
    ctlExpansion(id){
      // let isExpansion = this.data.isExpansion
      this.isExpansion = id
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.commentBox{background: #fff;border-bottom: 1px solid #F2F2F2}
.commentBox_down{padding: 15px 20px}
.comment{display: flex;justify-content: flex-start;align-items: center}
.headPortrait{width: 50px;height: 50px;border-radius: 50px}
.nameBox{margin-left: 10px}
.nameBox span{color: #999999;font-size: 12px}
.nameBox .name{display: block;color: #191919;font-size: 14px;font-weight: bold}
.triggerBox{padding-left: 60px;text-align: right;}
.triggerBox button{font-size: 12px;height: 1.2rem;line-height: 1.2rem;width: 3rem;display: inline-block}
.authorReply{color: #B0AA9E;font-size: 14px;padding-left: 60px;}
.commentText{font-size: 14px;color: #878787;margin-left: 60px}
.commentImageArray{margin-left: 60px;display: flex;justify-content: space-between;flex-wrap: wrap}
.commentImg{height: 70px;width: 90px}

.toggleExpand {color:#4472FC;font-weight: bold}
</style>
